<app-modal-filler-atom
  (click)="close()"
  [index]="index$ | async"
></app-modal-filler-atom>
<div
  class="fixed inset-x-0 shadow overflow-y-auto mdMax:bottom-0 mdMax:max-h-85-screen mdMax:max-w-screen-sm mdMax:mx-auto md:flex md:justify-center md:items-center md:w-full md:h-full md:top-0 md:left-0"
  [style.z-index]="(index$ | async) + 50"
>
  <app-modal-filler-atom
    *ngIf="isDesktop$ | async"
    [withBackdrop]="false"
    (click)="close()"
    [index]="index$ | async"
  ></app-modal-filler-atom>
  <div
    class="bg-white py-5 md:py-7 rounded-t-3xl md:rounded-3xl md:max-w-lg flex flex-col gap-3 lg:gap-5 px-5 md:px-7"
    [style.z-index]="(index$ | async) + 50"
  >
    <div class="flex justify-between items-center">
      <h2 class="font-accent font-bold text-xl">
        {{ 'pay-at-table.payment-confirmation.receipt.receive-my-receipt-by-mail' | translate }}
      </h2>
    </div>
    <p class="text-neutral-600 font-base">
      {{ 'pay-at-table.payment-confirmation.receipt.modal-description' | translate }}
    </p>
    <div class="text-neutral-800 leading-5">
      <label
        for="email"
        class="block mb-1 text-sm leading-5 font-base text-neutral-600 font-bold"
        >{{ 'pay-at-table.payment-confirmation.receipt.email' | translate }}</label
      >
      <input
        id="email"
        [(ngModel)]="email"
        class="w-full border border-neutral-800 rounded py-4.5 px-5 lg:w-448px"
        autofocus
      />
    </div>
    <div class="flex justify-between items-center mt-4">
      <div class="mr-2 xm:pr-1 w-full xm:w-1/2">
        <app-button-atom
          size="M"
          [label]="'comment-modal.cancel' | translate"
          color="primary"
          (click)="close()"
          type="light"
          [full]="true"
        ></app-button-atom>
      </div>
      <div class="xm:pl-1 w-full xm:w-1/2">
        <app-button-atom
          size="M"
          [label]="'comment-modal.validate' | translate"
          (click)="submit(email)"
          type="primary"
          [full]="true"
          [iconUrl]="submitInProgress ? 'assets/images/spinner.svg' : undefined"
          [disabled]="submitInProgress"
        ></app-button-atom>
      </div>
    </div>
  </div>
</div>
